import React, { useEffect, useState } from "react";
import { Box, Typography, Grid2 } from "@mui/material";
import { SearchOff } from "@mui/icons-material";
import HierarchicalSelector from "../../Common/HierarchicalSelector";
import DuplicateSignal from "../../Common/DuplicateSignal";
import { extractEntities } from "../../Common/CommonFunctions";
import EmptyState from "../../../../Helper/Loaders/EmptyState";

const EventsTab = ({
  eventHierarchyInputData,
  selectedEvents,
  onEventsChange,
  batteryID,
  isLoading = false,
}) => {
  const [selectedEventChips, setSelectedEventChips] = useState([]);
  const [showDuplicateError, setShowDuplicateError] = useState(false);

  useEffect(() => {
      const chips = selectedEvents.map(event => event.raw);
      setSelectedEventChips(chips);
    }, [selectedEvents]);

  const handleSelectionChange = (chips) => {
    const extractedEvents = extractEntities(batteryID, chips, eventHierarchyInputData);

    // map of existing event -> original data
    const existingEventMap = new Map(
      selectedEvents.map((event) => [
        `${event.id}_${event.metric}`,
        event
      ])
    );

    const eventsWithExtras = extractedEvents.map((event) => {
      const uniqueKey = `${event.id}_${event.metric}`;

      if (existingEventMap.has(uniqueKey)) {
        // keep existing event data
        return existingEventMap.get(uniqueKey);
      }

      // new event - return as is
      return event;
    });

    onEventsChange(eventsWithExtras);
  };

  const eventsNotAvailable =
    !isLoading &&
    Object.keys(eventHierarchyInputData).length > 0 &&
    Object.values(eventHierarchyInputData).every(
      (node) => Object.keys(node.children || {}).length === 0
    );

  return (
    <Grid2
      container
      flexDirection={'column'}
      justifyContent={'space-between'}
      sx={{ height: 'inherit', position: 'relative' }}
    >
      <Grid2 container gap={0.5} flexDirection={'column'}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
          <Grid2 container gap={0.5} alignItems={'center'}>
            <Typography variant="fw400s12c494949" sx={{ color: '#15191E', lineHeight: '24px' }}>
              Events
            </Typography>
          </Grid2>
        </Box>
        <HierarchicalSelector
          data={eventHierarchyInputData}
          selectedChips={selectedEventChips}
          onSelectionChange={handleSelectionChange}
          onDuplicateError={() => setShowDuplicateError(true)}
          placeholder="Define events"
          allowDuplicates={false}
          selectionMode="checklist"
          className="w-full"
          maxHeight={'240px'}
          isLoading={isLoading}
        />
        {eventsNotAvailable && (
          <EmptyState icon={<SearchOff />} message="No Events Available" />
        )}
      </Grid2>
      {showDuplicateError && <DuplicateSignal onClose={() => setShowDuplicateError(false)} />}
    </Grid2>
  );
};

export default EventsTab;
